import { render, staticRenderFns } from "./Version.vue?vue&type=template&id=74d455ab&scoped=true"
import script from "./Version.vue?vue&type=script&lang=js"
export * from "./Version.vue?vue&type=script&lang=js"
import style0 from "./Version.vue?vue&type=style&index=0&id=74d455ab&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d455ab",
  null
  
)

export default component.exports